import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Tabs, Card, Form, Input, Button, Select, DatePicker } from "antd";
import { Collapse, Tag } from "antd";
import useAuth from "../../hooks/useAuth";
import BillingTab from "./components/BillingTab";
import FAQ from "./components/FAQ";

const { TabPane } = Tabs;
const { Option } = Select;

const { Panel } = Collapse;

export default function Settings() {
	const { userData } = useAuth();
	const location = useLocation();
	const [form] = Form.useForm();

	const [activeTab, setActiveTab] = useState("1");

	const tabMapping = {
		billing: "2", // Assuming "billing" corresponds to the second tab
		profile: "1", // Assuming "profile" corresponds to the first tab
	};

	const onFinish = (values) => {
		console.log("Success:", values);
	};
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const tabParam = queryParams.get("tab"); // Get the value of the "tab" query parameter

		if (tabParam && tabMapping[tabParam]) {
			setActiveTab(tabMapping[tabParam]); // Set the active tab based on the query parameter
		}
	}, [location.search]);

	useEffect(() => {
		if (userData) {
			form.setFieldsValue({
				fullName: `${userData.firstName || ""} ${userData.lastName || ""}`,
				email: `${userData?.email || ""}`,
			});
		}
	}, [userData]);

	return (
		<div >
			<Card
				style={{
					borderRadius: "12px",
					boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
				}}
			>
				<Tabs
					defaultActiveKey="1"
					activeKey={activeTab}
					onChange={setActiveTab}
				>
					<TabPane tab="User Profile" key="1">
						<div style={{ padding: "24px" }}>
							<h2 style={{ marginBottom: "24px", color: "#333" }}>
								User Profile
							</h2>
							<Form
								form={form}
								name="user_profile"
								onFinish={onFinish}
								layout="vertical"
								initialValues={{
									fullName: `${userData?.firstName || ""} ${
										userData?.lastName || ""
									}`,
									email: `${userData?.email || ""}`,
								}}
							>
								<Form.Item
									label="Full Name"
									name="fullName"
									rules={[
										{ required: true, message: "Please input your full name!" },
									]}
								>
									<Input
										placeholder="Enter your full name"
										value={userData?.firstName + userData?.lastName}
										readOnly
									/>
								</Form.Item>
								<Form.Item
									label="Email"
									name="email"
									value={userData?.email}
									rules={[
										{ required: true, message: "Please input your email!" },
									]}
								>
									<Input placeholder="Enter your email" readOnly />
								</Form.Item>
								{/* <Form.Item
									label="Phone Number"
									name="phone"
									rules={[
										{
											required: true,
											message: "Please input your phone number!",
										},
									]}
								>
									<Input placeholder="Enter your phone number" />
								</Form.Item> */}
								{/* <Form.Item
									label="Date of Birth"
									name="dob"
									rules={[
										{
											required: true,
											message: "Please select your date of birth!",
										},
									]}
								>
									<DatePicker style={{ width: "100%" }} />
								</Form.Item> */}
								{/* <Form.Item
									label="Gender"
									name="gender"
									rules={[
										{ required: true, message: "Please select your gender!" },
									]}
								>
									<Select placeholder="Select your gender">
										<Option value="male">Male</Option>
										<Option value="female">Female</Option>
										<Option value="other">Other</Option>
									</Select>
								</Form.Item> */}
								<Form.Item>
									<Button
										type="primary"
										htmlType="submit"
										style={{ marginTop: "16px" }}
										disabled
									>
										Update Profile
									</Button>
								</Form.Item>
							</Form>
						</div>
					</TabPane>
					<TabPane tab="Billing" key="2">
						<div
							style={{
								padding: "24px",
								textAlign: "center",
							}}
						>
							<BillingTab />
						</div>
					</TabPane>
					<TabPane tab="Faq" key="3">
						<div
							style={{
								padding: "24px",
								textAlign: "center",
							}}
						>
							<FAQ />
						</div>
					</TabPane>
				</Tabs>
			</Card>
		</div>
	);
}
